const PAYMENT_RESPONSE_SET = 'PAYMENT_RESPONSE_SET';
const PAYMENT_RESPONSE_REMOVE = 'PAYMENT_RESPONSE_REMOVE';

export {
  PAYMENT_RESPONSE_SET,
  PAYMENT_RESPONSE_REMOVE,
};



// WEBPACK FOOTER //
// ./src/app/actions/payment-response/types.js